import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import '../css/ManageNotifications.css';
import api from '../utils/axiosConfig';


const ManageNotificationsAdmin = () => {
  const [notifications, setNotifications] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const [selectedParticipant, setSelectedParticipant] = useState('all');
  const [sortOption, setSortOption] = useState('');
  const [showAll, setShowAll] = useState(false);

  useEffect(() => {
    const fetchNotifications = async () => {
      try {
        const response = await api.get(`/api/notifications`);
        setNotifications(response.data.notifications);
        setLoading(false);
      } catch (err) {
        setError(err.response?.data?.error || 'Failed to fetch notifications');
        setLoading(false);
      }
    };

    fetchNotifications();
  }, []);


  const handleDelete = async (notificationId) => {
    if (!window.confirm('Sind Sie sicher, dass Sie diese Benachrichtigung löschen möchten?')) return;
    
    try {
        await api.delete(`/api/notifications/${notificationId}`);
        setNotifications(notifications.filter(notification => notification._id !== notificationId));
    } catch (err) {
      setError(err.response?.data?.message || 'Fehler beim Löschen der Benachrichtigung');
    }
  };


  if (loading) return <div className="loading">Loading...</div>;
  if (error) return <div className="error">{error}</div>;

  let filteredNotifications = [...notifications];

  if (selectedParticipant !== 'all') {
    filteredNotifications = filteredNotifications.filter(
      notification => notification.userCode === selectedParticipant
    );
  }

  if (sortOption === 'date-asc') {
    filteredNotifications.sort(
      (a, b) => new Date(a.scheduledAt) - new Date(b.scheduledAt)
    );
  }

  if (sortOption === 'date-desc') {
    filteredNotifications.sort(
      (a, b) => new Date(b.scheduledAt) - new Date(a.scheduledAt)
    );
  }

  if (sortOption === 'status-sent') {
    filteredNotifications.sort(
      (a, b) => (b.sent === true) - (a.sent === true)
    );
  }

  if (sortOption === 'status-pending') {
    filteredNotifications.sort(
      (a, b) => (a.sent === true) - (b.sent === true)
    );
  }

  const displayedNotifications = showAll
    ? filteredNotifications
    : [...filteredNotifications]
        .sort((a, b) => new Date(b.scheduledAt) - new Date(a.scheduledAt))
        .slice(0, 5);

  const uniqueParticipants = Array.from(
    new Set(notifications.map(notification => notification.userCode))
  );

  return (
  <div className="notification-list-container">

    <div className="notification-header">
      <h1>Zeitplan</h1>

      <div className="header-controls">

        {filteredNotifications.length > 5 && (
          <button
            type="button"
            className="show-all-button"
            onClick={() => setShowAll(!showAll)}
          >
            {showAll ? 'Weniger anzeigen' : 'Alle anzeigen'}
          </button>
        )}

        <select
          value={selectedParticipant}
          onChange={(e) => {
            setSelectedParticipant(e.target.value);
            setShowAll(false);
          }}
          className="participant-filter"
        >
          <option value="all">Alle Teilnehmer</option>

          {uniqueParticipants.map(code => (
            <option key={code} value={code}>
              {code}
            </option>
          ))}
        </select>

        <select
          value={sortOption}
          onChange={(e) => setSortOption(e.target.value)}
          className="sort-dropdown"
        >
          <option value="">Sortieren nach</option>
          <option value="date-asc">Datum ↑</option>
          <option value="date-desc">Datum ↓</option>
          <option value="status-sent">
            Status: Gesendet zuerst
          </option>
          <option value="status-pending">
            Status: Ausstehend zuerst
          </option>
        </select>

      </div>
    </div>

    <div className="notifications-table-wrapper">

      <table className="notifications-table">

        <thead>
          <tr>
            <th>Teilnehmer Code</th>
            <th>Session Name</th>
            <th>Datum & Uhrzeit</th>
            <th>Status</th>
            <th>Aktionen</th>
          </tr>
        </thead>

        <tbody>
          {displayedNotifications.map(notification => (
            <tr key={notification._id}>

              <td>{notification.userCode}</td>

              <td>{notification.sessionName}</td>

              <td>
                <span style={{ all: 'unset' }}>
                  {new Date(notification.scheduledAt).toLocaleString('de-DE', {
                    timeZone: 'Europe/Berlin',
                    hour12: false,
                    year: 'numeric',
                    month: '2-digit',
                    day: '2-digit',
                    hour: '2-digit',
                    minute: '2-digit',
                  })}
                </span>
              </td>

              <td>
                {notification.sent ? 'Gesendet' : 'Ausstehend'}
              </td>

              <td className="actions">

                <button
                  onClick={() =>
                    navigate(
                      `/dashboard/notifications/${notification._id}/edit`
                    )
                  }
                  className="edit-button"
                  disabled={notification.sent}
                >
                  Bearbeiten
                </button>

                <button
                  onClick={() => handleDelete(notification._id)}
                  className="delete-button"
                >
                  Löschen
                </button>

              </td>

            </tr>
          ))}
        </tbody>

      </table>

    </div>
  </div>
);
};

export default ManageNotificationsAdmin;